export default __webpack_public_path__ + "static/media/spinner.7f7b8c98.svg";